import React, { createContext, useContext, useState, useEffect } from "react";

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    const saved = localStorage.getItem("favorites");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  const addFavorite = (college) => {
    if (!favorites.some((f) => f.Institute_Code === college.Institute_Code)) {
      setFavorites([...favorites, college]);
    }
  };

  const removeFavorite = (instituteCode) => {
    setFavorites(favorites.filter((c) => c.Institute_Code !== instituteCode));
  };

  const isFavorite = (instituteCode) => {
    return favorites.some((c) => c.Institute_Code === instituteCode);
  };

  return (
    <FavoritesContext.Provider
      value={{ favorites, addFavorite, removeFavorite, isFavorite }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
